import React, { useContext } from 'react';

import { GenericP, Heading, ResponsiveContainer } from '../../../../common/Styles';
import { DescWrapper } from './descriptionStyles';

import { DescriptionTxt } from '../../config';
import { isMobileContext } from '../../../../UtilityComponents/Util';
import DisplayContext from '../../../../UtilityComponents/displayContext';

const Description = () => {
	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = isMobileContext(displayName);
	const { heading: headTxt, desc } = DescriptionTxt;
	return (
		<DescWrapper>
			<ResponsiveContainer isNoBTPadd>
				<Heading as={isMobile ? 'h3' : 'h1'} dangerouslySetInnerHTML={{ __html: headTxt }} />
				<GenericP top_M='32' fsize={isMobile ? '14px' : '20px'} text_align='center'>
					{desc}
				</GenericP>
			</ResponsiveContainer>
		</DescWrapper>
	);
};

export default Description;
